// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"AnswersList__AnswersList___1RCrZ"};